import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/layout/AppLayout';
import DashboardHeader from './DashboardHeader';
import MaterialSummary from './MaterialSummary';
import ExceptionView from './ExceptionView';
import {
    materialData,
    emergencyPurchases,
    excessConsumption,
    procurementForesightData
} from './data';
import { ArrowLeft } from 'lucide-react';

// Map materialData to API-like shape expected by MaterialSummary (monthlyInventory.items)
const getMonthlyInventoryFromDummy = () => {
    const statusToCriticality = (statusType) => {
        if (statusType === 'error') return 85;
        if (statusType === 'warning') return 110;
        return 125;
    };
    return {
        items: materialData.map((m) => ({
            itemId: m.id,
            itemName: m.name,
            unit: m.unit,
            opening: m.opening,
            in_transit: m.purchased,
            consumed: m.consumed,
            closing: m.closing,
            totalSpend: m.totalSpend,
            status: m.status,
            statusPercent: m.percentage,
            stock_criticality: statusToCriticality(m.statusType)
        }))
    };
};

const SampleInventoryMonthlyReport = () => {
    const navigate = useNavigate();
    const [activeView, setActiveView] = useState('Summary');
    const [summaryTab] = useState('Progress Overview');
    const monthlyInventory = getMonthlyInventoryFromDummy();
    const criticalItemsCount = materialData.filter((m) => m.statusType === 'error').length;

    return (
        <Layout>
            <div className="bg-[#F8FAFC] min-h-screen font-sans">
                <div className="bg-[#EEF3F7] p-6 flex flex-col gap-4 z-50 sticky top-0">
                    <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center gap-4">
                        <div className="flex flex-wrap items-center gap-3">
                            <button
                                type="button"
                                onClick={() => navigate('/builder/inventory/monthly-report')}
                                className="flex items-center gap-2 px-3 py-2 text-[#526477] hover:bg-gray-100 rounded-md transition-colors text-sm font-medium"
                            >
                                <ArrowLeft size={20} />
                                Back to Inventory Monthly Report
                            </button>
                            <span className="h-5 w-px bg-[#526477] opacity-50" />
                            <h1 className="text-lg font-bold text-[#111827]">Sample Inventory Monthly Report</h1>
                            <span className="px-2 py-0.5 bg-[#1F4B55] text-white text-xs font-semibold rounded">Preview</span>
                        </div>
                        <div className="text-sm text-[#526477] font-medium">
                            Project: Vedic Lifestyle · Sample data
                        </div>
                    </div>
                    <DashboardHeader
                        activeTab={activeView}
                        setActiveTab={setActiveView}
                        projectName="Vedic Lifestyle"
                        onProjectChange={() => {}}
                        date={new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)}
                        onDateChange={() => {}}
                        projects={[{ label: 'Vedic Lifestyle', id: 1, value: 1 }]}
                        criticalItemsCount={criticalItemsCount}
                    />
                </div>

                <div className="p-6">
                    <div className="animate-in fade-in duration-500">
                        {activeView === 'Summary' && (
                            <>
                                {summaryTab === 'Progress Overview' && (
                                    <MaterialSummary monthlyInventory={monthlyInventory} />
                                )}
                                {summaryTab === 'Minor Delays' && (
                                    <div className="flex items-center justify-center p-20 bg-white rounded-lg border border-gray-200 shadow-sm border-dashed">
                                        <p className="text-gray-400 font-medium">No minor delays reported.</p>
                                    </div>
                                )}
                            </>
                        )}

                        {activeView === 'Risk Overview' && (
                            <ExceptionView
                                procurementForesight={{
                                    items: procurementForesightData.map((p, i) => ({
                                        itemId: p.id,
                                        material: p.material,
                                        required: p.requiredQty,
                                        available: p.availableQty,
                                        toPurchase: p.toPurchase,
                                        timeline: 14,
                                        estimatedPrice: [2100000, 450000, 285000, 175000][i] ?? 0
                                    }))
                                }}
                                emergencyPurchases={emergencyPurchases}
                                excessConsumption={excessConsumption}
                            />
                        )}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default SampleInventoryMonthlyReport;
